/*
  Align Page Content
  Version: 03.03.20
  Author: Hal Wong

  Purpose:

  We require this module to reactively calculate the height of the header
  and apply top padding to the page content so that it will never be hidden
  behind the header area; which includes the nav and subnav bars.

  This is because the top banner on the webpage is in a fixed position and
  can have a variable height due to the fact that the nav and sub-nav menus
  are dynamically generated by the titles of the entries in CraftCMS, and
  also depending on the width of the browser, the sub-nav is additionally
  designed to collapse into multiple rows when the sub-nav exceeds the full-width
  of the page, which increases the height of the banner area, and subsequently,
  the necessity of this module.

  Assumptions:

  This module assumes that the DOM is Ready, the documenet and window objects
  are accessible, and the DOM objects 'header > nav' and 'main#main' are present.

  Instructions:

  This Module is self-executing and simply needs to be imported into the
  main application JS at src/js/app.js

*/

export default class AlignContent {
  constructor() {
    if (
      typeof document !== undefined &&
      typeof window !== undefined &&
      document.querySelector('main#main') !== null &&
      document.querySelector('header  > nav') !== null
    ) {
      const topAlign = () => {
        let oneRem = parseFloat(
          getComputedStyle(document.documentElement).fontSize
        );
        let paddingTop = document.querySelector('header  > nav').offsetHeight;
        document.querySelector('main#main').style.paddingTop =
          oneRem + paddingTop + 'px';
      };
      window.addEventListener('resize', topAlign);
      topAlign();
    }
  }
}
